<template>
	<div class="swipe">
		<swiper :options="swiperOption">
			<swiper-slide v-for="(item,index) in imgArr" :key="index">
				<img :src="item.src" />
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
	</div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
const imgArr = [{
	src: '/static/img/home_bg1.jpg'
}, {
	src: '/static/img/home_bg2.jpg'
}];
export default {
	name: 'swipe',
	components: {
		swiper,
		swiperSlide
	},
	data() {
		return {
			swiperOption: {
				pagination: '.swiper-pagination',
				paginationClickable: true,
				autoplay: 5000
			},
			imgArr: imgArr
		}
	}
}
</script>

<style scoped>
.swipe {
	left: 0;
	top: 0;
	width: 100%;
	margin: 0;
	padding: 0;
}

img {
	width: 100%;
	height: 100%;
	left: 0px;
}
</style>



// WEBPACK FOOTER //
// swipe.vue?78253241